// extracted by css-extract-rspack-plugin
export default {"sectionHeader":"_48451f0b","articleElement":"_24700b87","imgElement":"_64faece0","header":"_24def5e2"};